import React, {Component} from "react";
import './gridview.scss';
import AssistBar from "../components/assistbar";
// import TopNavbar from "./components/navbar";

class GridViewPage extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            listContent:{},
            category:null,
        }
      }

componentDidMount(){
 
   
}


  render(){

    return (
      <div className="gridviewpage-main">

        <AssistBar {...this.props} setval={this.props.setval} />

        <div className="title-bar">

            <div className="banner-wrapper">
                <img src={"/assets/banner-"+this.props.bannerCat+".PNG"} alt="banner" />
            </div>
           
            <div className="text-wrapper">
              {"browse our products"}  
            </div>
        </div>

        {
            Object.keys(this.props.filter).map((i)=>{
                return(
                    <div key={i} className="item-grid" onClick={(e)=>{
                        this.props.setval({
                            chosenProduct:{
                                "cat":this.props.filter[i]["parentCategory"],
                                "item":i,
                            },
                            currentPage:"detailpage",
                            previousView: "gridviewpage",
                        })
                    }}>
                    <div className="img-wrapper">
                        <img src={"/assets/"+this.props.filter[i]["parentCategory"]+"-"+i+"-1.PNG"} width="100%" />
                    </div>
                    <div className="text-wrapper-name">
                       <div className="text-name">{this.props.filter[i]["name"]}</div>
                    </div>
                    <div className="text-wrapper-price">
                       <div className="text-price">{(typeof(this.props.filter[i]["price"])==="object")?
                       (this.props.filter[i]["price"]["small"]===undefined? "starting from USD "+this.props.filter[i]["price"]["90CM"]:
                       "starting from USD "+this.props.filter[i]["price"]["small"]):"USD    "+this.props.filter[i]["price"]}</div>
                    </div>
                </div>
                )
            })
        }

        {/* <div className="item-bar">
            <div className="img-wrapper">
                <img src="/assets/wallart-item1-1.PNG" width="100%" />
            </div>
            <div className="text-wrapper">
               <div className="text-item">{this.props.productList["wallart"]["item1"]["name"]}</div>
               <div className="text-item">{this.props.productList["wallart"]["item1"]["description"]}</div>
               <div className="text-item">{this.props.productList["wallart"]["item1"]["price"]}</div>
            </div>
        </div> */}


      </div>
    );


  }
}

export default GridViewPage;
